import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  PostArrowBack,
  ContentBox,
  PostActionIcons,
  StatusContainer,
  EndStyle,
  StatusBox,
  UserInfo,
  UserProfile,
  UserDetails,
  PostMessageStyle,
  DocumentContainer,
  AboutAction,
  PostImage,
  PostPopOver,
  UserQuickPreview,
} from 'pages/home/Home.style.js';
import { Notification } from 'components/CustomNotification';
import { ActionList } from 'assert/OptionList';
import DynModel from 'components/Modal';
import {
  getActivityPostByid,
  getPostRelationReq,
  changePostRelations,
  getActivityPostList,
  getSavedPostList,
  getActivityByUserPostsList,
  deleteActivityPost,
  PostMessageReceive,
  ResetPostList,
  getActivityProfileByuserName,
  getSearchPostsList,
  getAuthActivityPostList,
  resetActivityPostByid,
} from 'redux/features/ActivityPostSlice';
import { AddLikesList, handleGetbyPostlikeId } from 'redux/features/LikeSlice';
import {
  BasicIconButton,
  BrandIconSpinner,
  Button,
  CloseIcon,
  CustomPopover,
  DocPreview,
  Virtuoso,
} from 'components';
import Comments from './Comment';
import { useNavigate, useParams } from 'react-router-dom';
import { Image } from 'antd';
import ShareModal from './ShareModal';
import moment from 'moment';
import { t } from 'i18next';
import clsx from 'clsx';
import { Skeleton, Tooltip } from '@mui/material';
import { ReactComponent as ProfilePic } from 'assert/images/Common/profileImg.svg';
import { ReactComponent as More } from 'assert/images/Home/moreHorizantal.svg';
import { ReactComponent as Save } from 'assert/images/More/save.svg';
import { ReactComponent as UnSave } from 'assert/images/More/unsave.svg';
import { ReactComponent as PostEdit } from 'assert/images/More/postEdit.svg';
import { ReactComponent as PostDifference } from 'assert/images/More/difference.svg';
import { ReactComponent as Mute } from 'assert/images/More/mute.svg';
import { ReactComponent as UnMute } from 'assert/images/More/unmute.svg';
import { ReactComponent as Block } from 'assert/images/More/block.svg';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { ReactComponent as Report } from 'assert/images/More/report.svg';
import { ReactComponent as ShareIcon } from 'assert/images/Home/share.svg';
import { ReactComponent as Info } from 'assert/images/More/info.svg';
import { ReactComponent as PersonAdd } from 'assert/images/More/personAdd.svg';
import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
// import { ReactComponent as NotificationIcon } from 'assert/images/More/notification.svg';
import { CountryCode } from 'redux/features/LoginSlice';
import ModalContent from './Content';
import VideoPlayer from 'components/Video';
import { MuteProvider } from 'components/MuteContext';
import { Helmet } from 'react-helmet';
import { highlightHTML, stripHtmlTags, swipeModalWidth } from 'utils/helper';
import { useTranslation } from 'react-i18next';
import { AuthContext } from 'router/AuthProvider';
import LoginNotification from 'pages/auth/LoginNotification';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import useWindowDimensions from 'components/Dimention';
import { SearchUserList } from 'pages/layout/Header';
import { SearchContainer } from 'pages/layout/Header.style';
import { Capacitor } from '@capacitor/core';
import { Share as ShareCapacitor } from '@capacitor/share';
import NativePullToRefresh from 'components/NativePullToRefresh';
import { ShareBaseUrl } from 'environment';
import ReportModal from 'components/ReportModal';

const SkeletonPostLoader = ({ contentHeight }) => {
  return (
    <div className="post-lazy-container">
      <div className="lazy-d-flex">
        <Skeleton animation="wave" variant="circular" width={40} height={40} />
        <div className="lazy-name">
          <Skeleton variant="rounded" width={120} height={12} />
          <Skeleton variant="rounded" width={90} height={12} />
        </div>
      </div>
      <Skeleton
        className="lazy-content"
        variant="rounded"
        width={'100%'}
        height={contentHeight || 40}
      />
      <div className="lazy-footer">
        <div className="lazy-d-flex">
          <Skeleton
            animation="wave"
            variant="circular"
            width={30}
            height={30}
          />
          <Skeleton
            animation="wave"
            variant="circular"
            width={30}
            height={30}
          />
          <Skeleton
            animation="wave"
            variant="circular"
            width={30}
            height={30}
          />
        </div>
        <div>
          <Skeleton animation="wave" variant="rounded" width={80} height={20} />
        </div>
      </div>
    </div>
  );
};

const PostList = React.memo(function PostList({
  view,
  keyword,
  createModalOpen,
}) {
  const dispatch = useDispatch();
  const { postId } = useParams();
  const navigate = useNavigate();
  const callCount = useRef(0);
  const descriptionRefs = useRef({});
  const { i18n } = useTranslation();
  const { width } = useWindowDimensions();
  const { isLoggedIn } = useContext(AuthContext);
  const isNative = Capacitor.isNativePlatform();

  const { relationStates, singlePost, activityList } = useSelector(
    (state) => state.PostActivitySlice
  );
  const { countryCode } = useSelector((state) => state?.LoginReducer);
  const { PostMessage } = useSelector((state) => state.PostActivitySlice);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [postModalOpen, setPostOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState(true);
  const [PostList, setPostList] = useState([]);
  const [editData, setEditData] = useState();
  const [commentOpen, setCommentOpen] = useState(false);
  const [postActionName, setPostActionName] = useState({ title: '', id: '' });
  const [Share, setShare] = useState(false);
  const [scrollData, setScrollData] = useState({ page: 0, size: 20 });
  const [likeUsers, setlikeUsers] = useState({});
  const [likeCount, setlikeCount] = useState({});
  const [loading, setloading] = useState(false);
  const [postLoading, setPostLoading] = useState(true);
  const [deletepostId, setDeletepostId] = useState(null);
  const [openPopover, setOpenPopover] = useState(false);
  const [tempPostSavedId, setTempPostSavedId] = useState([]);
  // const [tempDeleteCount, setTempDeleteCount] = useState(0);
  const [openUserPopover, setOpenUserPopover] = useState(null);
  const [likeLoading, setLikeLoading] = useState(false);
  const [showMoreMap, setShowMoreMap] = useState({});
  const [expandedMap, setExpandedMap] = useState({});
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);
  const [likeList, setLikeList] = useState([]);
  const [likeListOpen, setLikeListOpen] = useState(false);
  const [likeListLoading, setLikeListLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState();
  const [likeAnimationMap, setLikeAnimationMap] = useState({});
  const [isReportModalOpen, setIsReportModalOpen] = useState("");

  const loggedInUserId = String(getProfile?.userId);
  const isPostDetailpage = location.pathname.includes('/post-details');
  // const postTotalCount = activityList?.count - tempDeleteCount;

  useEffect(() => {
    setCurrentTime(moment().utc().format('YYYY-MM-DD HH:mm:ss'));
    !countryCode?.country_code && dispatch(CountryCode());
  }, []);

  const handlefetch = useCallback(() => {
    const page = scrollData.page;
    const size = scrollData.size;
    const code = countryCode?.country_code;

    if (location.pathname === '/') {
      dispatch(
        isLoggedIn
          ? getActivityPostList(loggedInUserId, currentTime, page, size, code)
          : getAuthActivityPostList(currentTime, page, size, code)
      );
    } else {
      let action = null;

      if (location.pathname === '/following') {
        action = getActivityPostList(loggedInUserId, currentTime, page, size);
      } else if (location.pathname.includes('/home/post')) {
        action = getActivityByUserPostsList(page, size);
      } else if (location.pathname.includes('/home/saved')) {
        action = getSavedPostList(page, size, '/post/savePost');
      } else if (location.pathname.includes('/home/comments')) {
        action = getSavedPostList(
          page,
          size,
          'user/profileActivityCommentsPost'
        );
      } else if (location.pathname.includes('/home/likes')) {
        action = getSavedPostList(page, size, 'user/profileActivityLikePost');
      } else if (location.pathname.includes('/search/posts')) {
        action = getSearchPostsList(keyword, page, size);
      }

      if (action) dispatch(action);
    }
  }, [
    loggedInUserId,
    scrollData,
    location.pathname,
    countryCode?.country_code,
    keyword,
    isLoggedIn,
  ]);

  useEffect(() => {
    setPostList([]);
    dispatch(ResetPostList());
    if (isPostDetailpage) {
      dispatch(getActivityPostByid(postId));
    }
    if (countryCode?.country_code && callCount.current === scrollData.page) {
      callCount.current += 1;
      setScrollData({
        page: scrollData.page + 1,
        size: scrollData.size,
      });
      handlefetch();
    }
  }, [postId, countryCode?.country_code]);

  useEffect(() => {
    if (activityList?.rows?.data?.length === 0 || PostList?.length > 0) {
      setPostLoading(false);
    }
  }, [activityList, PostList]);

  useEffect(() => {
    if (
      activityList?.rows?.data?.length > 0 ||
      singlePost
      // ||
      // postTotalCount === 0
    ) {
      const singlePostData = singlePost?.data?.postDetails;
      if (postId && isPostDetailpage && singlePostData) {
        setPostList([singlePostData]);
      } else {
        setPostList(activityList?.rows?.data ?? []);
      }
      const likeListById = {};
      const likeCountById = {};
      const savePostById = [];
      if (singlePostData) {
        likeListById['like' + singlePostData?.id] =
          singlePostData?.isLiked !== 0;
        likeCountById['likecount' + singlePostData?.id] =
          singlePostData?.likeCount;
        (singlePostData?.isPostSaved === 1 || view === 'save') &&
          savePostById.push(singlePostData?.id);
      } else {
        activityList?.rows?.data?.forEach((res) => {
          likeListById['like' + res?.id] = res?.isLiked !== 0;
          likeCountById['likecount' + res?.id] = res?.likeCount;
          (res?.isPostSaved === 1 || view === 'save') &&
            savePostById.push(res?.id);
        });
      }
      setlikeUsers((prevState) => ({
        ...prevState,
        ...likeListById,
      }));
      setlikeCount((prevState) => ({
        ...prevState,
        ...likeCountById,
      }));
      setTempPostSavedId(savePostById);
    }
    if (['profile', 'save', 'comments', 'likes', 'search'].includes(view)) {
      setPostList(activityList?.rows?.data);
    }
    if (!activityList?.rows && !singlePost) {
      ResetPostList();
      setPostList([]);
    }
  }, [activityList, postId, singlePost, view, location.pathname]);

  useEffect(() => {
    if (PostMessage?.status || !PostMessage?.status) {
      dispatch(PostMessageReceive(''));
      setloading(false);
      setOpenPopover(false);
      if (PostMessage?.data?.key === 'SAVE') {
        setTempPostSavedId([...tempPostSavedId, PostMessage?.data?.postId]);
      } else if (PostMessage?.data?.key === 'UNSAVE') {
        const removeSavedPostId = tempPostSavedId.filter(
          (item) => item !== PostMessage?.data?.postId
        );
        setTempPostSavedId(removeSavedPostId);
      }
    }
  }, [PostMessage]);

  const fetchMoreData = useCallback(() => {
    setScrollData((prev) => ({
      ...prev,
      page: prev.page + 1,
    }));
    handlefetch();
  }, [handlefetch]);

  const customPost = (data, item) => {
    if (data === 'edit') {
      setEditData(item);
      setPostOpenModal(true);
      setModalTitle(false);
    } else if (data === 'delete') {
      const deleteListUrls = item.documents
        ? [item.documents]
        : item.video
        ? [item.video]
        : item.images?.filter((n) => n);
      setDeletepostId({
        id: item.id || item.postId,
        attachment: deleteListUrls,
      });
    }
  };

  const checkUser = (id) => {
    if (loggedInUserId === id) {
      return true;
    } else {
      return false;
    }
  };

  const postActions = (title, postDetails, like) => {
    const POST_ID = postDetails?.id || postDetails?.postId;
    if (title === 'Like') {
      setLikeLoading(true);
      setlikeUsers((prevState) => ({
        ...prevState,
        ['like' + POST_ID]: !like,
      }));
      setlikeCount((prevState) => ({
        ...prevState,
        ['likecount' + POST_ID]: !like
          ? Number(likeCount['likecount' + POST_ID]) + 1
          : Number(likeCount['likecount' + POST_ID]) - 1,
      }));
      setLikeAnimationMap((prev) => ({
        ...prev,
        [POST_ID]: true,
      }));
      setTimeout(() => {
        setLikeAnimationMap((prev) => ({
          ...prev,
          [POST_ID]: false,
        }));
      }, 600);
      dispatch(
        AddLikesList({
          likedId: loggedInUserId,
          postId: POST_ID,
          like: !like,
          postcreatedById: postDetails?.createdById,
          likedByName: getProfile?.username,
        })
      )
        .then(() => {
          setLikeLoading(false);
        })
        .catch(() => {
          setLikeLoading(false);
        });
    } else if (title === 'Comment') {
      setCommentOpen(!commentOpen);
      setShare(false);
      setPostActionName((prev) => ({
        ...prev,
        title,
        id: POST_ID,
        createdById: postDetails?.createdById,
      }));
    } else if (title === 'Detail') {
      navigate(`/post-details/${POST_ID}`);
    }
  };

  const onCallRelations = (item) => {
    dispatch(
      getPostRelationReq({
        followerId: item?.createdById,
        userId: loggedInUserId,
      })
    );
  };

  const postDeleteFun = () => {
    dispatch(deleteActivityPost(deletepostId.id, deletepostId.attachment))
      .then((res) => {
        Notification('success', res?.message);
        setDeletepostId(null);
        setOpenPopover(false);
        // setTempDeleteCount(tempDeleteCount + 1);
      })
      .catch(() => {
        setDeletepostId(null);
        setOpenPopover(false);
      });
  };

  const onPostAction = (key, Item) => {
    setloading(true);
    let payload = {
      userId: loggedInUserId,
      followerId: Number(Item?.createdById),
      key,
      method:
        Item?.isPostSaved === 1 ? 'delete' : Item?.postId ? 'delete' : 'post',
      postId: Item?.id || Item?.postId,
    };
    switch (key) {
      case 'FOLLOW':
      case 'UNFOLLOW':
      case 'WITHDRAW':
        payload = {
          ...payload,
        };
        break;
      case 'MUTE':
        payload = {
          ...payload,
          mute: !relationStates.isMuted,
        };
        break;
      case 'BLOCK':
        payload = {
          ...payload,
          block: !relationStates.isBlocked,
        };
        break;
      default:
        break;
    }
    dispatch(changePostRelations(payload, 'callGet'));
  };

  const PostDropdown = useCallback(
    (Item) => {
      // Item?.isPostSaved === 1 || view === 'save'
      const isSave = tempPostSavedId.includes(Item?.id);
      const isUserInfoLoading =
        loading ||
        (Item?.createdById !== loggedInUserId &&
          Item?.username !== relationStates?.followerInfo?.username);
      return (
        <PostPopOver data-is-user-info-loading={isUserInfoLoading}>
          {isUserInfoLoading ? (
            <BrandIconSpinner customStyle="post-more-spinner" loading={true} />
          ) : (
            <>
              <div
                onClick={() => onPostAction(isSave ? 'UNSAVE' : 'SAVE', Item)}
              >
                {isSave ? <UnSave /> : <Save />}
                <div>{isSave ? t('HomePage.UnSave') : t('HomePage.Save')}</div>
              </div>
              {checkUser(Item?.createdById) && view !== 'save' && (
                <div
                  onClick={() => {
                    !(
                      Item.editCount >= 5 ||
                      handleCheckPostTime(Item?.created_At)
                    ) && customPost('edit', Item);
                  }}
                  className={clsx(
                    (Item.editCount >= 5 ||
                      handleCheckPostTime(Item?.created_At)) &&
                      'disable-action'
                  )}
                >
                  <PostEdit />
                  <div className="more-edit-post">
                    {t('HomePage.EditThePost')}
                  </div>
                  <div
                    className="edit-info-container"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <Tooltip
                      arrow
                      title={
                        <>
                          <span>{t('HomePage.InfoMsg')}</span>
                          <div className="edit-count">
                            <span>Edits of {Item.editCount || 0} to 5</span>
                          </div>
                        </>
                      }
                      classes={{ popper: 'edit-tooltip' }}
                      placement="bottom-end"
                    >
                      <Info />
                    </Tooltip>
                  </div>
                </div>
              )}
              {Item?.editCount > 0 && (
                <div
                  onClick={() => {
                    navigate(`/post-history/${Item?.id}`);
                  }}
                >
                  <PostDifference />
                  <div>{t('HomePage.ViewOriginalPost')}</div>
                </div>
              )}
              {!checkUser(Item?.createdById) && (
                <div
                  onClick={() => {
                    onPostAction(
                      relationStates?.isRequested
                        ? `WITHDRAW`
                        : relationStates?.isAccepted &&
                          !relationStates?.isRejected &&
                          !relationStates?.isBlocked
                        ? 'UNFOLLOW'
                        : 'FOLLOW',
                      Item
                    );
                  }}
                >
                  <PersonAdd />
                  <div>
                    {relationStates?.isRequested
                      ? t(`HomePage.Withdraw`)
                      : relationStates?.isAccepted &&
                        !relationStates?.isRejected &&
                        !relationStates?.isBlocked
                      ? t('HomePage.Unfollow')
                      : t('HomePage.Follow')}
                    {' @' + relationStates?.followerInfo?.username}
                  </div>
                </div>
              )}
              {!checkUser(Item?.createdById) && (
                <>
                  <div
                    className="post-mute-icon"
                    onClick={() => onPostAction('MUTE', Item)}
                  >
                    {relationStates?.isMuted ? <UnMute /> : <Mute />}
                    <div>
                      {relationStates?.isMuted
                        ? t('HomePage.UnMute')
                        : t('HomePage.Mute')}
                      {' @' + relationStates?.followerInfo?.username}
                    </div>
                  </div>
                  <div onClick={() => onPostAction('BLOCK', Item)}>
                    <Block className="post-block-icon" />
                    <div>
                      {relationStates?.isBlocked
                        ? t('HomePage.UnBlock')
                        : t('HomePage.Block')}
                      {' @' + relationStates?.followerInfo?.username}
                    </div>
                  </div>
                </>
              )}
              {checkUser(Item?.createdById) && view !== 'save' && (
                <div
                  onClick={() => customPost('delete', Item)}
                  className="deletelist-icon"
                >
                  <Delete />
                  <div>{t('HomePage.Delete')}</div>
                </div>
              )}
              {!checkUser(Item?.createdById) && (
                <div
                  onClick={() => {
                    setIsReportModalOpen(Item?.id);
                  }}
                  className="deletelist-icon"
                >
                  <Report />
                  <div>{t('BusinessPlace.Report')}</div>
                </div>
              )}
            </>
          )}
        </PostPopOver>
      );
    },
    [relationStates, tempPostSavedId, loading]
  );

  const handleCheckPostTime = (createdAt) => {
    return moment().diff(moment(createdAt), 'hours') >= 1;
  };

  const handleCallUserInfo = (username) => {
    dispatch(getActivityProfileByuserName(username))
      .then((response) => {
        setOpenUserPopover(response?.data?.data);
      })
      .catch((err) => {
        Notification('error', err.response?.data?.message);
      });
  };

  const toggleExpand = (postId) => {
    setExpandedMap((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const map = {};
      Object.entries(descriptionRefs.current).forEach(([key, el]) => {
        if (el) {
          const style = getComputedStyle(el);
          let lineHeight = parseFloat(style.lineHeight);

          if (isNaN(lineHeight)) {
            const fontSize = parseFloat(style.fontSize) || 16;
            lineHeight = fontSize * 1.2;
          }

          const maxHeight = 13 * lineHeight;
          map[key] = el.scrollHeight > maxHeight;
        }
      });

      setShowMoreMap(map);
    }, 200);

    return () => clearTimeout(timer);
  }, [PostList]);

  const handleOpenLikeList = (id) => {
    setLikeListLoading(true);
    setLikeListOpen(true);
    dispatch(handleGetbyPostlikeId(id))
      .then((res) => {
        setLikeList(res?.data?.data);
        setLikeListLoading(false);
      })
      .catch(() => {
        setLikeList([]);
        setLikeListLoading(false);
      });
  };

  const handleItemContent = (index, item) => {
    const isLikedPost = likeUsers['like' + (item?.id || item?.postId)];
    const likedCount = likeCount['likecount' + (item?.id || item?.postId)];
    const imageLength = item?.images?.length;
    if (!item?.id) {
      return [];
    }
    return (
      <StatusBox
        key={index}
        id={'post_' + (item?.id || item?.postId)}
        className="statusBox"
      >
        <UserInfo>
          <div className="about-info">
            <CustomPopover
              isOpen={openUserPopover && openUserPopover?.username}
              handlePopoverClick={() => {
                if (!isLoggedIn) return;
                handleCallUserInfo(item?.username);
              }}
              enableHover={isLoggedIn}
              disabled
              className="quick-preview-popover"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              action={
                <UserProfile>
                  {item?.profileImage ? (
                    <img
                      src={item?.profileImage}
                      alt="user-profile-img"
                      className="profile-img"
                    />
                  ) : (
                    <ProfilePic className="profile-img" />
                  )}
                </UserProfile>
              }
              content={
                <UserQuickPreview>
                  <div className="quick-preview-header">
                    <div>
                      {item?.profileImage ? (
                        <img
                          src={item?.profileImage}
                          alt="user-profile-img"
                          className="quick-preview-img"
                        />
                      ) : (
                        <ProfilePic className="quick-preview-svgpic" />
                      )}
                    </div>
                    <div
                      className="quick-preview-seeprofile"
                      onClick={() =>
                        navigate('/profile/' + openUserPopover?.username)
                      }
                    >
                      {t('HomePage.SeeProfile')}
                    </div>
                  </div>
                  <div className="quick-preview-displayname">
                    {openUserPopover?.displayName}
                  </div>
                  <div className="quick-preview-username">
                    {'@' + openUserPopover?.username}
                  </div>
                  {openUserPopover?.headline && (
                    <div className="quick-preview-headline">
                      {openUserPopover?.headline}
                    </div>
                  )}
                  <div className="quick-preview-follow-container">
                    <div>
                      <b>{openUserPopover?.followerCount}</b>{' '}
                      {t('HomePage.Follower')}
                    </div>
                    <div>
                      <b>{openUserPopover?.followingCount}</b>{' '}
                      {t('HomePage.Following')}
                    </div>
                  </div>
                </UserQuickPreview>
              }
            />

            <UserDetails>
              <div className="post-displayname-flex">
                <div
                  className="display-name"
                  onClick={() => navigate('/profile/' + item?.username)}
                >
                  {item?.displayName}
                </div>
                <div className="post-time">
                  {'· ' + moment(item?.updated_At).fromNow(true)}
                  {item?.editCount > 0 ? ' · Edited' : null}
                </div>
              </div>
              <div className="user-name">{'@' + item?.username}</div>
            </UserDetails>
          </div>
          <CustomPopover
            isOpen={openPopover}
            handlePopoverClick={() => {
              if (isLoggedIn) {
                setOpenPopover(true);
                if (item?.createdById !== loggedInUserId) {
                  onCallRelations(item);
                }
              } else {
                setIsLoginNotificationOpen(true);
              }
            }}
            disableRefClick={!isLoggedIn}
            action={
              <BasicIconButton
                icon={<More />}
                size="small"
                className="post-more-btn"
              />
            }
            content={PostDropdown(item)}
          />
        </UserInfo>

        {item?.description !== '' && (
          <PostMessageStyle className="postMessageStyle">
            <div
              ref={(el) => (descriptionRefs.current[item?.id || index] = el)}
              className={clsx(
                'description-section',
                (location.pathname === '/' ||
                  location.pathname === '/following') &&
                  !expandedMap[item?.id] &&
                  'description-line-clamp'
              )}
              style={{
                maxHeight: expandedMap[item?.id] ? '9999px' : undefined,
              }}
              dangerouslySetInnerHTML={{
                __html: keyword
                  ? highlightHTML(item?.description, keyword)
                  : item?.description,
              }}
            />
            {!isPostDetailpage &&
              showMoreMap[item?.id] &&
              !expandedMap[item?.id] && (
                <div
                  className="see-more-container"
                  onClick={() => toggleExpand(item?.id)}
                >
                  <span className="see-more">
                    {/* {expandedMap[item?.id]
                    ? t('HomePage.SeeLess')
                    :  */}
                    {t('HomePage.SeeMore')}
                  </span>
                </div>
              )}
          </PostMessageStyle>
        )}
        {imageLength > 0 && !item?.images?.includes(null) && (
          <PostImage imglength={imageLength} className="post-image">
            <div
              className={
                imageLength > 1 ? 'preview-parent3' : 'singleimgparent'
              }
            >
              <Image.PreviewGroup items={item?.images}>
                {item?.images?.slice(0, 4)?.map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      {imageLength === 1 ? (
                        <div key={index} className="single-img">
                          <Image src={data} />
                        </div>
                      ) : (
                        <div
                          className={`${
                            imageLength === 3
                              ? `img-index${index}`
                              : imageLength === 4
                              ? 'img-len4'
                              : 'preview-child'
                          }`}
                          key={index}
                        >
                          <Image src={data} />
                          {index === 3 && (
                            <div className="preview-img-count">
                              +{imageLength - 4}
                            </div>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </Image.PreviewGroup>
            </div>
          </PostImage>
        )}
        {item?.documents && item?.documents !== '' && (
          <DocumentContainer>
            <DocPreview src={item?.documents} readOnly={true} />
          </DocumentContainer>
        )}
        {item?.video !== '' && <VideoPlayer src={item?.video} />}
        <AboutAction className="aboutAction">
          <div>
            {ActionList.map((data, index) => {
              return (
                ((isPostDetailpage && index === 1) || !isPostDetailpage) && (
                  <PostActionIcons
                    key={data.title}
                    icon={isLikedPost && index === 1 ? 'Unlike' : data.title}
                  >
                    <div
                      key={data.title}
                      title={isLikedPost && index === 1 ? 'Unlike' : data.title}
                      className={clsx(
                        'post-icons',
                        'like-icon-wrapper',
                        {
                          'like-icon-animate':
                            index === 1 && likeAnimationMap[item?.id],
                        },
                        !item?.comment && index === 0 && 'post-disable-icon'
                      )}
                      onClick={() => {
                        if (isLoggedIn) {
                          !likeLoading &&
                            (item?.comment || index !== 0) &&
                            postActions(data.title, item, isLikedPost);
                        } else {
                          setIsLoginNotificationOpen(true);
                        }
                      }}
                    >
                      {index === 1 && isLikedPost
                        ? data?.filledIcon
                        : data.icon}
                    </div>
                    {item?.comment && index === 0 ? (
                      <div className="postActionCount">
                        {index === 0 &&
                          item?.commentCount > 0 &&
                          item?.commentCount}
                      </div>
                    ) : (
                      ''
                    )}
                    {index === 1 && (
                      <div
                        className={clsx(
                          'postActionCount',
                          getProfile?.username === item?.username &&
                            'like-count-action'
                        )}
                        onClick={() =>
                          getProfile?.username === item?.username
                            ? handleOpenLikeList(item?.id || item.postId)
                            : {}
                        }
                      >
                        {index === 1 && likedCount > 0 && likedCount}
                      </div>
                    )}
                  </PostActionIcons>
                )
              );
            })}
          </div>
          <div
            className="share-icon"
            onClick={() => {
              if (isNative) {
                const postDescription = stripHtmlTags(item?.description || '');
                const shareText = `${
                  postDescription.length <= 280
                    ? postDescription
                    : `${postDescription.slice(0, 280)}...`
                }\n`;
                ShareCapacitor.share({
                  title: 'New post on Wafynet',
                  text: shareText,
                  url: `${ShareBaseUrl}/post-details/${
                    item?.id || item?.postId
                  }`,
                  dialogTitle: 'Share with...',
                });
              } else {
                setShare(!Share);
              }
              setCommentOpen(false);
              setPostActionName((prev) => ({
                ...prev,
                id: item?.id || item.postId,
              }));
            }}
          >
            <ShareIcon /> <div key={i18n.language}>{t('HomePage.Share')}</div>
          </div>
        </AboutAction>
      </StatusBox>
    );
  };

  const closePostModal = useCallback(
    (data) => {
      setPostOpenModal(data);
      setModalTitle(true);
    },
    [modalTitle]
  );

  const handleVirtuoso = useCallback(() => {
    return (
      <Virtuoso
        data={PostList}
        useWindowScroll
        // minHeight={view ? '78vh' : '100vh'}
        increaseViewportBy={{ top: 4000, bottom: 1000 }}
        components={{
          Footer: () => {
            return (
              !activityList?.hasMore && (
                <EndStyle customPadding={'0px 0px 80px'}>
                  <span>* * *</span>
                </EndStyle>
              )
            );
          },
        }}
        endReached={
          activityList?.hasMore && callCount.current !== 0
            ? fetchMoreData
            : () => {}
        }
        itemContent={(index, item) => handleItemContent(index, item)}
      />
    );
  }, [
    PostList,
    relationStates,
    likeUsers,
    likeCount,
    tempPostSavedId,
    openPopover,
    openUserPopover,
    loading,
    likeLoading,
    showMoreMap,
    expandedMap,
    activityList?.hasMore,
    likeAnimationMap,
  ]);

  const handleRefresh = () => {
    setPostLoading(true);
    setCurrentTime(moment().utc().format('YYYY-MM-DD HH:mm:ss'));
    setPostList([]);
    dispatch(ResetPostList());
    setScrollData({
      page: 0,
      size: scrollData.size,
    });
    setTimeout(() => {
      const page = 0;
      const size = scrollData.size;
      const code = countryCode?.country_code;
      if (location.pathname === '/') {
        dispatch(
          isLoggedIn
            ? getActivityPostList(loggedInUserId, currentTime, page, size, code)
            : getAuthActivityPostList(currentTime, page, size, code)
        );
      } else {
        let action = null;

        if (location.pathname === '/following') {
          action = getActivityPostList(loggedInUserId, currentTime, page, size);
        } else if (location.pathname.includes('/home/post')) {
          action = getActivityByUserPostsList(page, size);
        } else if (location.pathname.includes('/home/saved')) {
          action = getSavedPostList(page, size, '/post/savePost');
        } else if (location.pathname.includes('/home/comments')) {
          action = getSavedPostList(
            page,
            size,
            'user/profileActivityCommentsPost'
          );
        } else if (location.pathname.includes('/home/likes')) {
          action = getSavedPostList(page, size, 'user/profileActivityLikePost');
        }
        if (action) dispatch(action);
      }
    }, 500);
  };

  const enableRefresh =
    !isPostDetailpage &&
    !createModalOpen &&
    !postModalOpen &&
    !commentOpen &&
    !likeListOpen &&
    !isLoginNotificationOpen &&
    !deletepostId &&
    !Share;

  return (
    <>
      {isPostDetailpage && (
        <Helmet>
          <title>
            {PostList?.[0]?.description
              ? `${stripHtmlTags(PostList?.[0]?.description).slice(0, 50)}${
                  stripHtmlTags(PostList?.[0]?.description).length > 50
                    ? '... | Post | WafyNet'
                    : ' | Post | WafyNet'
                }`
              : 'Post Details | WafyNet'}
          </title>
          <meta
            name="description"
            content={
              PostList?.[0]?.description
                ? stripHtmlTags(PostList?.[0]?.description).slice(0, 150)
                : 'Discover user-shared posts, updates, and content on WafyNet.'
            }
          />
        </Helmet>
      )}
      {isPostDetailpage && (
        <PostArrowBack className="post-back">
          <CloseIcon
            iconType={'back'}
            onClick={() => {
              navigate(-1);
              dispatch(resetActivityPostByid());
            }}
          />
          <div>{t('HomePage.Post')}</div>
        </PostArrowBack>
      )}
      <DynModel
        modalchanges="postModal"
        openModal={postModalOpen}
        modelTitle={
          modalTitle ? t('HomePage.CreatePost') : t('HomePage.EditPost')
        }
        handleCancelModal={() => closePostModal(false)}
        maxWidth={false}
        fullWidth={false}
        content={
          <ModalContent
            closePostModal={() => closePostModal(false)}
            modalTitle={modalTitle}
            editData={editData}
          />
        }
      />
      <MuteProvider>
        <ContentBox>
          <StatusContainer view={view}>
            {postLoading && (
              <>
                <SkeletonPostLoader />
                {!isPostDetailpage && (
                  <>
                    <SkeletonPostLoader contentHeight={100} />
                    <SkeletonPostLoader contentHeight={80} />
                  </>
                )}
              </>
            )}
            {view !== 'profile' &&
              !loading &&
              !postLoading &&
              PostList?.length <= 0 && (
                <div className="no-data-found">
                  {!keyword && <NoDataFound />}
                  <div>{t('HomePage.NoPostFound')}</div>
                </div>
              )}
            <NativePullToRefresh
              onRefresh={enableRefresh ? handleRefresh : () => {}}
              enabled={enableRefresh}
            >
              {!isPostDetailpage && PostList?.length > 0 && handleVirtuoso()}
            </NativePullToRefresh>
            {width >= swipeModalWidth ? (
              <DynModel
                handleCancelModal={() => {
                  setCommentOpen(false);
                }}
                openModal={commentOpen}
                modalchanges={'comment-modal'}
                modelTitle={t('HomePage.Comment')}
                width={700}
                closable
                content={
                  <Comments
                    postId={postActionName?.id}
                    currentTime={moment().utc().format('YYYY-MM-DD HH:mm:ss')}
                    disableCmt={true}
                    postData={postActionName}
                  />
                }
              />
            ) : (
              <SwipeableEdgeDrawer
                title={t('HomePage.Comment')}
                openDrawer={commentOpen}
                handleCloseDrawer={() => setCommentOpen(false)}
              >
                <Comments
                  postId={postActionName?.id}
                  currentTime={moment().utc().format('YYYY-MM-DD HH:mm:ss')}
                  disableCmt={true}
                  postData={postActionName}
                />
              </SwipeableEdgeDrawer>
            )}
            {width >= swipeModalWidth ? (
              <DynModel
                handleCancelModal={() => {
                  setLikeListOpen(false);
                }}
                openModal={likeListOpen}
                modalchanges={'comment-modal'}
                modelTitle={'Liked By'}
                width={500}
                closable
                content={
                  <SearchContainer>
                    {likeList?.map((item, index) => {
                      return (
                        <div key={index}>
                          <SearchUserList
                            data={item}
                            loading={likeListLoading}
                          />
                        </div>
                      );
                    })}
                  </SearchContainer>
                }
              />
            ) : (
              <SwipeableEdgeDrawer
                title={'Liked By'}
                openDrawer={likeListOpen}
                handleCloseDrawer={() => setLikeListOpen(false)}
              >
                <SearchContainer>
                  {likeList?.map((item, index) => {
                    return (
                      <div key={index}>
                        <SearchUserList data={item} loading={likeListLoading} />
                      </div>
                    );
                  })}
                </SearchContainer>
              </SwipeableEdgeDrawer>
            )}
            <DynModel
              handleCancelModal={() => {
                setShare(false);
              }}
              openModal={Share}
              modalchanges={'share-modal'}
              modelTitle={t('HomePage.Share')}
              width={500}
              closable
              content={
                <ShareModal path={`/post-details/${postActionName?.id}`} />
              }
            />
            <DynModel
              removeHeader
              modalchanges="postDelete"
              handleCancelModal={() => setDeletepostId(null)}
              openModal={deletepostId !== null}
              content={
                <div className="confirmModal">
                  <div className="title">{t('HomePage.PostDel')}</div>
                  <div>
                    <Button
                      label={t('HomePage.Cancel')}
                      variant="text"
                      onClick={() => setDeletepostId(null)}
                    />
                    <Button
                      label={t('HomePage.Yes')}
                      color="error"
                      onClick={postDeleteFun}
                    />
                  </div>
                </div>
              }
            />
          </StatusContainer>
        </ContentBox>

        {isPostDetailpage && (
          <Comments
            postId={postId}
            isDetailPage={isPostDetailpage}
            detailPost={handleItemContent(0, PostList?.[0])}
            currentTime={moment().utc().format('YYYY-MM-DD HH:mm:ss')}
            disableCmt={PostList?.[0]?.comment}
            postData={PostList?.[0]}
          />
        )}

        <LoginNotification
          isLoginNotificationOpen={isLoginNotificationOpen}
          handleUpdateModal={() => setIsLoginNotificationOpen(false)}
        />
      </MuteProvider>
      <ReportModal
        resourceType={'post'}
        resourceId={isReportModalOpen}
        handleCloseReportModal={(data) => {
          setIsReportModalOpen(false);
          if(data?.closePopover) {
            setOpenPopover(false);
          }
        }}
      />
    </>
  );
});

export default PostList;
